'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { useSearchUiStore } from '@/features/search/model/ui/store';
import { useSearch } from '@/shared/hooks/useSearch';
import { SearchIcon, Typography } from '@/shared/ui/atoms';
import { CustomButton } from '@/shared/ui/molecules';
interface AutoCompleteKeywordProps {
  keyword: string;
  autoCompleteKeyword: string;
}
const AutoCompleteKeyword = t0 => {
  const $ = _c(26);
  const {
    keyword,
    autoCompleteKeyword
  } = t0;
  const router = useRouter();
  const pathParams = useParams();
  const searchParams = useSearchParams();
  const {
    updateRecentSearchKeywordList
  } = useSearch();
  const {
    setIsSearchBarFocused
  } = useSearchUiStore();
  let beforeKeyword;
  let keywordIndex;
  let t1;
  if ($[0] !== autoCompleteKeyword || $[1] !== keyword) {
    keywordIndex = autoCompleteKeyword.indexOf(keyword);
    beforeKeyword = autoCompleteKeyword.slice(0, keywordIndex);
    t1 = autoCompleteKeyword.slice(keywordIndex, keywordIndex + keyword.length);
    $[0] = autoCompleteKeyword;
    $[1] = keyword;
    $[2] = beforeKeyword;
    $[3] = keywordIndex;
    $[4] = t1;
  } else {
    beforeKeyword = $[2];
    keywordIndex = $[3];
    t1 = $[4];
  }
  const matchedKeyword = t1;
  let t2;
  if ($[5] !== autoCompleteKeyword || $[6] !== keyword.length || $[7] !== keywordIndex) {
    t2 = autoCompleteKeyword.slice(keywordIndex + keyword.length);
    $[5] = autoCompleteKeyword;
    $[6] = keyword.length;
    $[7] = keywordIndex;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const afterKeyword = t2;
  const fullKeyword = matchedKeyword ? `${beforeKeyword}${matchedKeyword}${afterKeyword}` : `${autoCompleteKeyword}`;
  let t3;
  if ($[9] !== autoCompleteKeyword || $[10] !== fullKeyword || $[11] !== pathParams?.locale || $[12] !== router || $[13] !== searchParams || $[14] !== setIsSearchBarFocused || $[15] !== updateRecentSearchKeywordList) {
    t3 = () => {
      updateRecentSearchKeywordList(autoCompleteKeyword);
      setIsSearchBarFocused(false);
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      let pathQuery = "";
      if (searchParams?.get("region")) {
        pathQuery = `&region=${searchParams?.get("region")}`;
      }
      if (searchParams?.get("treatment")) {
        pathQuery = pathQuery + `&treatment=${searchParams?.get("treatment")}`;
      }
      router.push(`/${pathParams?.locale}/search/result?query=${fullKeyword}${pathQuery}`);
    };
    $[9] = autoCompleteKeyword;
    $[10] = fullKeyword;
    $[11] = pathParams?.locale;
    $[12] = router;
    $[13] = searchParams;
    $[14] = setIsSearchBarFocused;
    $[15] = updateRecentSearchKeywordList;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const handleClick = t3;
  let t4;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="w-[28px] h-[28px] flex items-center justify-center bg-gray-100 rounded-lg"><SearchIcon size={20} className="text-[#AEB0B6]" /></div>;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== afterKeyword || $[19] !== autoCompleteKeyword || $[20] !== beforeKeyword || $[21] !== matchedKeyword) {
    t5 = <Typography size={16} lineHeight={22} className="text-gray-800">{matchedKeyword ? <><span>{beforeKeyword}</span><span className="text-primary-600 font-medium">{matchedKeyword}</span><span>{afterKeyword}</span></> : <span>{autoCompleteKeyword}</span>}</Typography>;
    $[18] = afterKeyword;
    $[19] = autoCompleteKeyword;
    $[20] = beforeKeyword;
    $[21] = matchedKeyword;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== handleClick || $[24] !== t5) {
    t6 = <CustomButton onMouseDown={_temp} onClick={handleClick} className="flex items-center gap-2 py-3">{t4}{t5}</CustomButton>;
    $[23] = handleClick;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
export default AutoCompleteKeyword;
function _temp(e) {
  e.preventDefault();
}